module.exports = __webpack_public_path__ + "static/screenshot-527cdc549f99e3e277ba8a64e8782599.png";